import { createSlice } from '@reduxjs/toolkit';
import { SurveyRejectReason } from '@mytypes';
import { fetchSavedDeliverySettings, logoutAdmin, logoutUser } from '~/api';

type SurveyRejectHistoryState = {
  history: SurveyRejectReason[] | null;
};

const initialState: SurveyRejectHistoryState = {
  history: null,
};

const surveyRejectHistorySlice = createSlice({
  name: 'surveyRejectHistory',
  initialState,
  reducers: {
    initialize: () => initialState,
  },
  // 非同期はextraReducersで行う
  extraReducers: (builder) => {
    builder
      .addCase(fetchSavedDeliverySettings.fulfilled, (state, action) => ({
        ...state,
        history: action.payload.surveyRejectHistory as SurveyRejectReason[] | null,
      }))
      .addCase(logoutAdmin.fulfilled, () => initialState)
      .addCase(logoutUser.fulfilled, () => initialState);
  },
});

// reducerをexportする
export default surveyRejectHistorySlice.reducer;
